import { createAction } from 'redux-actions';

export const SET_MINI_GAMES_DATA = 'SET_MINI_GAMES_DATA';
export const setMiniGamesData = createAction(SET_MINI_GAMES_DATA);

export const SET_CURRENTSCORE = 'SET_CURRENTSCORE';
export const setCurrentScore = createAction(SET_CURRENTSCORE);

export const ADD_GAME_TO_HISTORY = 'ADD_GAME_TO_HISTORY';
export const addGameToHistory = createAction(ADD_GAME_TO_HISTORY);

export const SET_HIGHSCORE = 'SET_HIGHSCORE';
export const setHighScore = createAction(SET_HIGHSCORE);

export const SET_MINI_GAMES_LIST = 'SET_MINI_GAMES_LIST';
export const setMiniGamesList = createAction(SET_MINI_GAMES_LIST);
